import { useState, useEffect } from "react";
import { LOGO } from "@/lib/catalog";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <header data-testid="site-header" className={`sticky top-0 z-40 bg-white transition-[border] ${scrolled ? "border-b border-black" : "border-b border-transparent"}`}>
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" aria-label="The Quick Brownie" data-testid="header-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="The Quick Brownie" className="h-9 md:h-10 w-auto" />
          <span className="font-display text-lg md:text-xl tracking-tight hidden sm:inline">The Quick Brownie</span>
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm">
          <button data-testid="nav-galeria" onClick={() => goTo("galeria")} className="hover:underline underline-offset-4">Galeria</button>
          <button data-testid="nav-sabores" onClick={() => goTo("sabores")} className="hover:underline underline-offset-4">Sabores</button>
          <button data-testid="nav-manifesto" onClick={() => goTo("manifesto")} className="hover:underline underline-offset-4">Manifesto</button>
          <button data-testid="nav-pedido" onClick={() => goTo("pedido")} className="hover:underline underline-offset-4">Pedido</button>
          <button data-testid="nav-faq" onClick={() => goTo("faq")} className="hover:underline underline-offset-4">FAQ</button>
        </nav>
        <button data-testid="header-cta" onClick={() => goTo("pedido")} className="btn-primary !px-5 !py-2.5 text-xs md:text-sm">
          Peça agora
        </button>
      </div>
      <div className="hairline" />
    </header>
  );
}
